export function formatWeight(str?: string) {
  if (!str) return '';

  return str.replace(/ /g, '_');
}
